import { render, staticRenderFns } from "./TableOverview.vue?vue&type=template&id=2a761ba8&scoped=true&"
import script from "./TableOverview.vue?vue&type=script&lang=ts&"
export * from "./TableOverview.vue?vue&type=script&lang=ts&"
import style0 from "./TableOverview.vue?vue&type=style&index=0&id=2a761ba8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a761ba8",
  null
  
)

export default component.exports